export function getIssueSchema() {
  return [
    {
      name: "id",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: [],
      helperText: "",
      nullable: false,
      readOnly: true,
      error: false,
    },
    {
      name: "equipment_id",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: [],
      helperText: "",
      nullable: true,
      readOnly: true,
      error: false,
    },
    {
      name: "observation_id",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: [],
      helperText: "",
      nullable: true,
      readOnly: true,
      error: false,
    },
    {
      name: "checklist_id",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: [],
      helperText: "",
      nullable: true,
      readOnly: true,
      error: false,
    },
    {
      name: "Issue Description",
      default: "",
      type: "string",
      maxLength: 255,
      selectables: [],
      similair: ["desc", "note", "notes", "issue", "issues", "describe"],
      nullable: false,
      readOnly: false,
      helperText: "",
      error: false,
    },
    {
      name: "Status",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [
        "Open",
        "In Progress",
        "Pending Review",
        "Owner Accepted (Closed)",
        "Designer Accepted (Closed)",
        "Manufacturer Accepted (Closed)",
        "Closed",
      ],

      similair: ["status"],
      helperText: "",
      nullable: false,
      readOnly: false,
      error: false,
    },
    {
      name: "Priority",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: ["High", "Medium", "Low", "N/A"],
      similair: ["level", "severity", "priorties"],
      helperText: "",
      nullable: false,
      readOnly: false,
      error: false,
    },
    {
      name: "Assigned To",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: ["Designers", "Contractors", "Owners"],
      similair: ["assigned", "assign"],
      helperText: "",
      nullable: true,
      readOnly: false,
      error: false,
    },
    {
      name: "Discipline",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: [
        "group",
        "group Name",
        "category",
        "category Name",
        "categories",
      ],
      helperText: "",
      nullable: true,
      readOnly: false,
      error: false,
    },
    {
      name: "Drawing",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: [
        "group",
        "group Name",
        "category",
        "category Name",
        "categories",
      ],
      helperText: "",
      nullable: true,
      readOnly: false,
      error: false,
    },
    {
      name: "Due Date",
      default: "",
      type: "date",
      maxLength: 80,
      selectables: [],
      similair: ["due", "target date"],
      helperText: "",
      nullable: true,
      readOnly: false,
      error: false,
    },
    {
      name: "Recommended Action",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: [
        "action",
        "recommend",
        "recommended",
        "spec",
        "required action",
      ],
      helperText: "",
      nullable: true,
      readOnly: false,
      error: false,
    },
  ];
}
